import type { Id } from '../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type LookupSiteEncryptionInfo = {
  sessionId: Id
  encryptionKey: Id
}

export const LookupSiteEncryptionInfoSchema: CborSchema<LookupSiteEncryptionInfo> =
  defineCborSchema<LookupSiteEncryptionInfo>({
    sessionId: CborField({ key: 0 }),
    encryptionKey: CborField({ key: 1 }),
  })
